import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { PageElements } from '../components/PageElements';
import Avatar from '../components/Avatar/Avatar';

const PageContainer = styled(PageElements)`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Text = styled.div`
  margin-top: 1rem;
  max-width: 370px;
`;

const Maintenance = () => (
  <PageContainer>
    <Avatar width={140} height={140} />
    <Text>
      Hei, <br />
      Parannamme palvelua juuri nyt. Palvelu on käytössäsi taas noin tunnin
      kuluttua! Päivitä sivu, nähdäksesi olemmeko valmiita. <br />
      <Link href="/">Päivitä sivu tästä</Link>
    </Text>
    <br />
    <Text>
      Hej, <br />
      Just nu håller vi på att förbättra vår service men kom tillbaka om ungefär
      en timme! Uppdatera sidan för att testa om vi är klara.
      <br />
      <Link href="/">Uppdatera sidan här</Link>
    </Text>
  </PageContainer>
);

export default Maintenance;
